import { EmbeddedApiService } from 'embedded/api/EmbeddedApiService';
import { inMethods } from 'app/glue/interop/in-methods';
import { OutMessagePayload } from 'embedded/api/out/OutMessage';
import { outMethods } from 'app/glue/interop/out-methods';
import {
    GlueApi,
    GlueInvoke,
    GlueOutInteropMethodNames,
} from 'app/glue/interop/types';
import { Logger } from '@instinet-analytics/core-lib';

export async function registerInteropMethods(
    glue: GlueApi,
    embeddedApiService: EmbeddedApiService,
    logger: Logger
) {
    if (!glue.agm) {
        return;
    }

    for (const inMethod of inMethods) {
        await glue.agm.register(
            {
                name: inMethod.name,
                displayName: inMethod.displayName,
                description: inMethod.description,
                accepts: inMethod.accepts,
            },
            (args: unknown) => inMethod.handler(embeddedApiService, args)
        );
    }

    function wrapInvoke<T>(wrapping: GlueInvoke<T>): GlueInvoke<T> {
        return (methodName: GlueOutInteropMethodNames, payload: T) => {
            const methodFilter = { name: methodName };
            const filteredMethods = glue.agm.methods(methodFilter);
            if (filteredMethods.length === 0) {
                logger.debug(`No listener for ${methodName} via Glue42`);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return Promise.resolve({} as any);
            }

            return wrapping(methodName, payload);
        };
    }

    const invoke = glue.agm.invoke.bind(glue.agm);

    for (const outMethod of outMethods) {
        await embeddedApiService.subscribe<OutMessagePayload>(
            {
                uuid: 'glue42',
                name: 'Glue42 Embedded API proxy',
            },
            outMethod.topic,
            outMethod.listener(wrapInvoke(invoke))
        );
    }
}
